<div class="bu-main-container">
  <div class="bu-container">
    <div class="bu-container__title">
      {{ upload_texts.title }}
    </div>
    <div class="bu-container__text">{{ upload_texts.subtitle }}</div>

    <avv-upload
      class="bu-container__file-input"
      id="upload-bi-document"
      [helperTexts]="helperTexts"
      [value]="fileStatus"
      (change)="onChange()"
      (isDeleted)="onDelete()"
      deletetype="BUTTON"
    ></avv-upload>

    <div class="bu-container__btn-container">
      <button
        class="bu-container__btn-container-btn btn btn-degraded blue"
        (click)="continue()"
        [disabled]="fileStatus.status !== 'SUCCESS'"
        id="btn"
      >
        Continuar
      </button>
    </div>
  </div>
</div>
